import { useRef, useState } from "react";
import { isFileDrag } from "../../hooks/useFileDrop";

// Тип данных, под которым карточка видео кладёт себя в dataTransfer
export const VERSION_DRAG_TYPE = "application/x-7cut-version";

const isVersionDrag = (e) =>
  Array.from(e.dataTransfer?.types || []).includes(VERSION_DRAG_TYPE);

/**
 * Папка, на которую можно бросить карточку видео (перемещение)
 * или видеофайлы с диска (загрузка в эту папку).
 *
 * children({ isOver, dropHandlers }) — render-prop.
 */
const DropTarget = ({ disabled, onMoveVersion, onDropFiles, children }) => {
  const [isOver, setIsOver] = useState(false);
  const counter = useRef(0);

  const accepts = (e) =>
    !disabled &&
    ((isVersionDrag(e) && !!onMoveVersion) || (isFileDrag(e) && !!onDropFiles));

  const dropHandlers = {
    onDragEnter: (e) => {
      if (!accepts(e)) return;
      e.preventDefault();
      e.stopPropagation();
      counter.current += 1;
      setIsOver(true);
    },
    onDragLeave: (e) => {
      if (!accepts(e)) return;
      e.stopPropagation();
      counter.current = Math.max(0, counter.current - 1);
      if (counter.current === 0) setIsOver(false);
    },
    onDragOver: (e) => {
      if (!accepts(e)) return;
      e.preventDefault();
      e.stopPropagation();
      e.dataTransfer.dropEffect = isVersionDrag(e) ? "move" : "copy";
    },
    onDrop: (e) => {
      if (!accepts(e)) return;
      e.preventDefault();
      e.stopPropagation();
      counter.current = 0;
      setIsOver(false);

      if (isVersionDrag(e)) {
        try {
          const payload = JSON.parse(e.dataTransfer.getData(VERSION_DRAG_TYPE));
          onMoveVersion(payload);
        } catch (err) {
          // чужие данные с тем же типом — игнорируем
        }
        return;
      }
      const files = Array.from(e.dataTransfer.files || []).filter((f) =>
        f.type.startsWith("video/")
      );
      if (files.length) onDropFiles(files);
    },
  };

  return children({ isOver, dropHandlers });
};

export default DropTarget;
